import UserApplications from '../views/UserBase/UserApplications';
import UserSearchJobs from '../views/UserBase/UserSearchJobs';
import UserMyProfile from '../views/UserBase/UserMyProfile';
// import UserDocuments from '../views/UserBase/UserDocuments';
import UserSubscriptions from '../views/UserBase/UserSubscriptions';
import UserSettings from '../views/UserBase/UserSettings';
import SignOut from '@/components/SignOut/SignOut';
import CandidateJobAd from '../views/UserBase/UserSearchJobsItem';
import SharkMan from '../views/UserBase/UserSharkManGame';
import SupportBase from '../views/SupportBase';
import FreelancingNetwork from '../views/UserBase/FreelancingNetwork';

const url_prefix = process.env.VUE_APP_URL_PREFIX;

export default [
  {
    path: '/user',
    redirect: url_prefix + '/user/profile',
    meta: {
      requiresAuth: true,
      candidateAuth: true,
    },
  },
  {
    path: '/user/applications',
    name: 'user-applications',
    component: UserApplications,
    meta: {
      requiresAuth: true,
      candidateAuth: true,
    },
  },
  {
    path: '/user/profile',
    name: 'user-profile',
    component: UserMyProfile,
    meta: {
      requiresAuth: true,
      candidateAuth: true,
    },
  },
  {
    path: '/user/jobs',
    name: 'user-search-jobs',
    component: UserSearchJobs,
    meta: { requiresAuth: true, candidateAuth: true },
  },
  {
    path: '/user/freelancing-network',
    name: 'freelancing-network',
    component: FreelancingNetwork,
    meta: { requiresAuth: true, candidateAuth: true },
  },
  {
    path: '/user/sharkman',
    name: 'sharkman',
    component: SharkMan,
    meta: { requiresAuth: true, candidateAuth: true },
  },
  {
    path: '/user/jobs/:jobad_id',
    name: 'user-jobs',
    component: CandidateJobAd,
    meta: { requiresAuth: true, candidateAuth: true },
  },
  /*  {
    path: url_prefix + '/user/documents',
    name: 'user-documents',
    component: UserDocuments,
    meta: { requiresAuth: true, candidateAuth: true },
  }, */
  {
    path: '/user/subscriptions',
    name: 'user-subscriptions',
    component: UserSubscriptions,
    meta: { requiresAuth: true, candidateAuth: true },
  },
  {
    path: '/user/settings',
    name: 'candidate-user-settings',
    component: UserSettings,
    meta: { requiresAuth: true, candidateAuth: true },
  },
  {
    path: '/logout',
    name: 'logout',
    component: SignOut,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/signin',
    name: 'signin-mobile',
    component: () => import('../components/Signin/MobileSignIn'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/register',
    name: 'register-mobile',
    component: () => import('../components/Register/MobileRegister'),
    meta: {
      requiresAuth: false,
    },
  },

  {
    path: '/user/support',
    name: 'candidate-support',
    component: SupportBase,
    meta: { requiresAuth: true, candidateAuth: true },
  },
];
